var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 787,
    height: 596,
    viewBox: "0 0 787 596",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_531_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.05 416.056L196.989 417.365C165.664 417.783 135.051 408.019 109.753 389.541C69.7271 360.305 47.4607 312.609 50.7504 263.152L51.1758 256.755C54.2479 210.569 77.637 168.121 115.04 140.852L163.874 105.247C221.045 63.5643 291.654 44.5878 362.018 51.9946L364.935 52.3016C424.457 58.5671 480.636 82.8976 525.926 122.025L663.311 240.716C699.057 271.599 722.555 314.268 729.543 360.988L735.004 397.496C741.404 440.285 725.909 483.432 693.748 512.374C666.649 536.76 630.49 548.531 594.228 544.769L565.553 541.795C542.77 539.432 520.587 533.048 500.034 522.941L480.646 513.407C460.721 503.609 442.131 491.303 425.329 476.787L413.533 466.596C380.252 437.843 338.837 420.178 295.05 416.056Z",
    fill: "url(#paint0_linear_531_108)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_531_108",
    x: 0.430664,
    y: 0.423828,
    width: 785.993,
    height: 595.033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_531_108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_531_108",
    x1: 553.5,
    y1: 62.5,
    x2: 382,
    y2: 508.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.ed200f346fb5f00d0e0fe6a897c17c7b.svg";
export { ForwardRef as ReactComponent };